import React, { Component } from "react"
import styled from "styled-components"
import themeGet from "@styled-system/theme-get"
import { Card } from "@xingternal/360-components"
import { ErrorView } from "@/components"

const ErrorContainer = styled.div`
  height: 100vh;
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: space-around;
`

const ErrorCard = styled(Card)`
  padding: ${themeGet("space.7")};
`

const ErrorScreen = (props) => (
  <ErrorContainer data-testid="error-container">
    <ErrorCard>
      <ErrorView {...props} />
    </ErrorCard>
  </ErrorContainer>
)

class ErrorBoundary extends Component {
  constructor(props) {
    super(props)

    this.state = { error: null }
  }

  componentDidCatch(error) {
    this.setState({ error })
  }

  render() {
    const {
      state: { error },
      props: { children },
    } = this

    return error ? (
      <ErrorScreen action={() => window.location.reload()} />
    ) : (
      children
    )
  }
}

export default ErrorBoundary
